import { apiSlice } from '../apiSlice';
import {
	AddStaffDTO,
	StaffInfoResDto,
	StaffListSummaryItem,
	EditStaffDTO,
	StaffResDto,
	StaffFilter,
	DeleteStaffListSummaryItem,
	DeleteStaffFilter,
} from '../DTO/staff/staffList.interface';
import { SuccessResponse, Paginated, Option } from '../DTO/common.interface';

export const staffApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getStaffInfo: builder.query<
			SuccessResponse<StaffInfoResDto>,
			string | undefined
		>({
			query: (staffId) => ({
				url: `/web/staffs/${staffId}`,
			}),
			providesTags: ['StaffInfo'],
		}),

		getStaffPage: builder.query<
			SuccessResponse<Paginated<StaffListSummaryItem>>,
			StaffFilter
		>({
			query: (body) => ({
				url: `/web/staffs/page`,
				method: 'POST',
				body,
			}),
		}),
		getDeleteStaffPage: builder.query<
			SuccessResponse<Paginated<DeleteStaffListSummaryItem>>,
			DeleteStaffFilter
		>({
			query: (body) => ({
				url: `/web/staffs/remove-page`,
				method: 'POST',
				body,
			}),
		}),

		addStaff: builder.mutation<SuccessResponse<StaffResDto>, AddStaffDTO>({
			query: (body) => ({
				url: `web/staffs`,
				method: 'POST',
				body,
			}),
		}),

		deleteStaff: builder.mutation<SuccessResponse<StaffResDto>, string>({
			query: (userId) => ({
				url: `web/staffs/${userId}`,
				method: 'DELETE',
			}),
		}),

		editStaff: builder.mutation<
			SuccessResponse<StaffListSummaryItem>,
			EditStaffDTO
		>({
			query: (body) => ({
				url: `/web/staffs`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['StaffInfo'],
		}),
	}),
});

export const {
	useGetStaffPageQuery,
	useGetStaffInfoQuery,
	useGetDeleteStaffPageQuery,
	useAddStaffMutation,
	useEditStaffMutation,
	useDeleteStaffMutation,
} = staffApiSlice;
